module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "desktop-wrapper"
  }, [_c('desktop-header', {
    attrs: {
      "calname": _vm.calInfo.name,
      "schoolname": _vm.schoolName
    },
    on: {
      "locale": _vm.setLocale
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('week-selector', {
    attrs: {
      "startDate": _vm.calInfo.start_date,
      "endDate": _vm.calInfo.end_date,
      "date": _vm.date
    },
    on: {
      "changed": _vm.setDate
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box cal-container"
  }, [_c('full-calendar-header', {
    attrs: {
      "locale": _vm.locale,
      "date": _vm.date,
      "calview": _vm.calView,
      "isNotThisWeek": _vm.isNotThisWeek
    },
    on: {
      "today": _vm.setToday,
      "prevWeek": _vm.prevWeek,
      "nextWeek": _vm.nextWeek
    }
  }), _vm._v(" "), _c('full-calendar', {
    attrs: {
      "calendarId": _vm.calId,
      "locale": _vm.locale,
      "caldate": _vm.date,
      "events": _vm.allEvents,
      "viewState": _vm.calInfo.view_state,
      "i18n": _vm.i18n
    },
    on: {
      "eventclick": _vm.showEvent,
      "view": _vm.setView
    }
  })], 1), _vm._v(" "), _c('weekplan', {
    attrs: {
      "locale": _vm.locale,
      "calId": _vm.calId,
      "date": _vm.date,
      "events": _vm.allEvents,
      "calview": _vm.calView.type
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3b657902!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/Desktop/DesktopView.vue
// module id = 1538
// module chunks = 1